export default __webpack_public_path__ + "maps-examples-offline-storage-thumbnail-960-c41fdd02f8e5788a3a28645b04ad8680.webp";